import {UnitEconomicsCalculationsFormField} from "../types/unit-economics-calculations-form-field.types";
import {Validators} from "@angular/forms";

export const unitEconomicsCalculationsFormFields: Array<UnitEconomicsCalculationsFormField> = [
  {
    label: 'Наименование',
    fieldName: 'name',
    type: 'text',
    validators: [ Validators.required ]
  },
  {
    label: 'Ссылка',
    fieldName: 'url',
    type: 'text',
    validators: [ Validators.required ]
  },
  {
    label: 'Комментарий',
    fieldName: 'comment',
    type: 'textarea'
  }
]
